var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasAccess
    ? _c(
        "Button",
        {
          staticClass: "btn-sm",
          nativeOn: {
            click: function ($event) {
              return _vm.edit.apply(null, arguments)
            },
          },
        },
        [_vm._v("Edit")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }